import axios from "axios";
import Cookies from "js-cookie";

const baseUrl = "https://white-label-backend.octalooptechnologies.com";

// Start Call request
const startCall = (name, email, agentId, customerId) => {
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrl}/start_call/${name}/${email}/${agentId}/${customerId}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        console.log("rrr", err);
        reject(err);
      });
  });
};
const handlePayment = (email, name, agentId) => {
  const data = JSON.stringify({
    name: name,
    email: email,
    agent_id: agentId,
  });

  console.log("data", data);
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrl}/initiate-payment`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        resolve(res.data);
        console.log("data", data);
      })
      .catch((err) => {
        reject(err);
        console.log("data", data);
      });
  });
};

//Ounbound call request
const outboundCall = (to_number, customer_id, agent_id, name, email) => {
  return new Promise((resolve, reject) => {
    axios
      .post(`${baseUrl}/twilio/outbound_call`, {
        to_number,
        customer_id,
        agent_id,
        name,
        email,
      })

      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

//check session request
const checkSession = (email, sessionid) => {
  // const email = Cookies.get("userEmail");
  // const session_id = Cookies.get("sessionId");
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrl}/check_session/${email}/${sessionid}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// End Call request
const endCall = (email, sessionid) => {
  // const email = Cookies.get("userEmail");
  // const session_id = Cookies.get("sessionId");
  return new Promise((resolve, reject) => {
    axios
      .get(`${baseUrl}/end_call/${email}/${sessionid}`, {})
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

// Submit Review request
const submitReview = (name, email, comment, rating) => {
  return new Promise((resolve, reject) => {
    const payload = {
      name,
      email,
      comment,
      rating,
      agent: "3X5LBEVlKcVj7sjX4bnS",
    };

    axios
      .post(`${baseUrl}/api/submit-review`, payload)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export {
  startCall,
  checkSession,
  endCall,
  submitReview,
  handlePayment,
  outboundCall,
};
